export class MissingDisputesModel {
    public id: any;
    public kpi_id: any;
    public comm_plan_id: number;
    public cust: any;
    public cust_id: any;
    public corp: number;
    public house: number;
    public revenue: any;
    public wordate: string;
    public wfindate: string;
    public message: string;
    public comment: string;
    public created_dt: any;
    public created_by: string;
    public updated_dt: string;
    public updated_by: string;
    public wordt: string;
    public wfindt: string;
    public createddt: string;
    public sales_rep_id: string;
    public sc_emp_id: string;
    public calRunId: string;
    public finalizeddate: string;
    public accnumber: string;
    public disputetype: string;
    public kpidisplayname: string;

    constructor() {
        this.kpidisplayname = null;
        this.disputetype = null;
        this.finalizeddate = null;
        this.accnumber = null;
        this.sc_emp_id = null;
        this.calRunId = null;
        this.sales_rep_id = null;
        this.wordt = null;
        this.wfindt = null;
        this.createddt = null;
        this.id = null;
        this.kpi_id = null;
        this.comm_plan_id = null;
        this.cust_id = null;
        this.corp = null;
        this.house = null;
        this.revenue = null;
        this.wordate = null;
        this.wfindate = null;
        this.message = null;
        this.comment = null;
        this.created_dt = null;
        this.created_by = null;
        this.updated_dt = null;
        this.updated_by = null;
    }
}